import { POPUP, LIST_QUOTE } from '../constants'

const initState = {
	request: null,
	response: null,
	error: null,
}

export default (state = initState, action) => {
	switch (action.type) {
		case LIST_QUOTE.LOAD:
			return {
				...state,
				request: action.request,
				response: null,
				error: null,
			}
		case LIST_QUOTE.SUCCESS:
			return {
				...state,
				response: action.response,
			}
		case LIST_QUOTE.ERROR:
			return {
				...state,
				error: action.error,
			}
		case POPUP.CLOSE:
			return {
				...state,
				error: null,
			}
		default:
			return state
	}
}
